import axios from 'axios'

const apiKey =
  process.env.VUE_APP_GOOGLE_API_KEY ||
  'AIzaSyCQ2dUgmx18CROzd1WeBP9AYSPbfMiP02Q'

export const extractFileId = (url: string) => {
  if (!url) return null

  const patterns = [
    /\/file\/d\/([^/]+)/, // /file/d/{fileId}/ format
    /id=([^&]+)/, // id={fileId} format
    /\/d\/([^/]+)/, // /d/{fileId}/ format
  ]

  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match && match[1]) {
      return match[1]
    }
  }

  return null
}

export const createThumbnailUrl = (fileId: string) => {
  if (!fileId) return null
  return `https://lh3.googleusercontent.com/sd/${fileId}=s220`
}

export const createPreviewUrl = (fileId: string) => {
  if (!fileId) return undefined
  return `https://drive.google.com/file/d/${fileId}/preview`
}

export const getFileMetadata = async (fileId: string) => {
  const url = `https://www.googleapis.com/drive/v3/files/${fileId}`
  try {
    const { data } = await axios.get(url, {
      params: {
        key: apiKey,
        fields: 'name,mimeType,thumbnailLink',
      },
    })
    return data
  } catch (error) {
    console.error('Error fetching file metadata:', error)
    throw error
  }
}

export const downloadFile = async (
  fileId: string,
  onProgress: (progress: number) => void
) => {
  const metadata = await getFileMetadata(fileId)
  validateMediaDimensions(metadata)
  validateFileType(metadata)

  const strategies = [
    `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${apiKey}`,
    `https://drive.google.com/uc?export=download&id=${fileId}`,
    `https://docs.google.com/uc?export=download&id=${fileId}`,
  ]

  for (const url of strategies) {
    try {
      const { data } = await axios.get(url, {
        responseType: 'arraybuffer',
        onDownloadProgress: progressEvent => {
          if (onProgress) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / (progressEvent.total || 1)
            )
            onProgress(percentCompleted)
          }
        },
      })
      return data
    } catch (error) {
      console.warn(`Failed to download from ${url}, trying next strategy...`)
    }
  }

  throw new Error('All download strategies failed.')
}
export const validateMediaDimensions = (metadata: any) => {
  // Check for image dimensions
  if (
    metadata.mimeType &&
    metadata.mimeType.startsWith('image/') &&
    metadata.imageMediaMetadata
  ) {
    const { width, height } = metadata.imageMediaMetadata
    if (width > 1920 || height > 1080) {
      throw new Error(
        'Image dimensions exceed the maximum allowed size of 1920x1080'
      )
    }
  }

  // Check for video dimensions
  if (
    metadata.mimeType &&
    metadata.mimeType.startsWith('video/') &&
    metadata.videoMediaMetadata
  ) {
    const { width, height } = metadata.videoMediaMetadata
    if (width > 1920 || height > 1080) {
      throw new Error(
        'Video dimensions exceed the maximum allowed size of 1920x1080'
      )
    }
  }

  return true
}
export const validateFileType = (metadata: any) => {
  const allowedTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'video/mp4',
    'audio/mp3',
    'audio/mpeg', // MP3 files can also have this MIME type
  ]

  if (!metadata.mimeType || !allowedTypes.includes(metadata.mimeType)) {
    throw new Error(
      'File type not allowed. Only MP4, JPG, PNG, WEBP, and MP3 files are supported.'
    )
  }

  return true
}
